export const CATEGORY_LABELS = {
    customer_number: 'Klanten',
    customer_name: 'Klanten',
    employee_bsn: 'Werknemers',
    employee_email: 'Werknemers',
    employee_phone: 'Werknemers',
    entity_kvk: 'Entiteiten',
    entity_lh: 'Entiteiten',
    entity_name: 'Entiteiten',
    user: 'Gebruikers',
    contact: 'Contactpersonen',
};

export const SEARCH_HINTS = [
    { label: 'Klantnummer', example: '1234', description: '4-5 cijfers' },
    { label: 'BSN', example: '123456789', description: '8-9 cijfers' },
    { label: 'KVK-nummer', example: '12345678', description: '8 cijfers' },
    {
        label: 'LH-nummer',
        example: '000018615L10',
        description: 'Loonheffingennummer',
    },
    {
        label: 'E-mailadres',
        example: 'jan@bedrijf.nl',
        description: 'Werknemer of gebruiker',
    },
    {
        label: 'Telefoonnummer',
        example: '+31612345678',
        description: 'Begint met + of 0',
    },
    {
        label: 'Naam',
        example: 'Jansen',
        description: 'Klant, entiteit, gebruiker of contact',
    },
];
